import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  modalImage();
  scrollEffect();
  pageLoading();
  initHomeMvIntro();
  initServiceSwiper();
});


/***********************************************************************
　ローディング後のMVアニメーション
***********************************************************************/

const initHomeMvIntro = () => {
  if (!document.body.classList.contains('home')) return;

  const mvImage = document.querySelector('.home_mv_image');
  const mvTitleSpans = document.querySelectorAll('.home_mv_ttl span');
  if (!mvImage || !mvTitleSpans.length) return;

  let hasPlayed = false;
  const playIntro = () => {
    if (hasPlayed) return;
    hasPlayed = true;

    gsap.timeline()
      .to(mvImage, {
        scale: 1,
        duration: 1.6,
        ease: 'power2.out'
      }, 0)
      .to(mvTitleSpans, {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        stagger: 0.2
      }, 0);
  };

  gsap.set(mvImage, { scale: 1.1, transformOrigin: 'center center' });
  gsap.set(mvTitleSpans, { autoAlpha: 0, y: 28 });

  document.addEventListener('pageLoading:complete', playIntro, { once: true });
  window.addEventListener('load', playIntro, { once: true });
};

/***********************************************************************
　お問い合わせ関連＋ページ内リンクのスムーススクロール
***********************************************************************/
// // //お問い合わせバリデーション
if(document.body.classList.contains("home")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// ヘッダーナビのページ内リンクをスムーススクロールにする
document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.hd_nav_li a');
  const sectionNavItems = [];
  let homeNavItem = null;

  const clearCurrentNav = () => {
    document.querySelectorAll('.hd_nav_li.is-current').forEach((item) => {
      item.classList.remove('is-current');
    });
  };

  const setCurrentNav = (navItem) => {
    clearCurrentNav();
    if (navItem) {
      navItem.classList.add('is-current');
    }
  };

  navLinks.forEach((link) => {
    const navItem = link.closest('.hd_nav_li');
    const href = link.getAttribute('href');
    if (!navItem || !href) return;

    let linkUrl;
    try {
      linkUrl = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    const isSamePage =
      linkUrl.origin === window.location.origin &&
      linkUrl.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');

    if (!isSamePage) return;

    if (!linkUrl.hash) {
      homeNavItem = navItem;
      return;
    }

    const target = document.querySelector(linkUrl.hash);
    if (!target) return;

    sectionNavItems.push({ navItem, target });
  });

  const updateCurrentNav = () => {
    if (!sectionNavItems.length) return;

    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const triggerLine = headerHeight + 24;

    const activeSection = sectionNavItems.find(({ target }) => {
      const rect = target.getBoundingClientRect();
      return rect.top <= triggerLine && rect.bottom > triggerLine;
    });

    if (activeSection) {
      setCurrentNav(activeSection.navItem);
      return;
    }

    const firstSectionTop = sectionNavItems[0].target.getBoundingClientRect().top;
    if (homeNavItem && firstSectionTop > triggerLine) {
      setCurrentNav(homeNavItem);
      return;
    }

    clearCurrentNav();
  };

  navLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || !href.includes('#')) return;

      let linkUrl;
      try {
        linkUrl = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      const isSamePage =
        linkUrl.origin === window.location.origin &&
        linkUrl.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');

      if (!isSamePage || !linkUrl.hash) return;

      const target = document.querySelector(linkUrl.hash);
      if (!target) return;

      event.preventDefault();

      const header = document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 0;

      gsap.to(window, {
        duration: 0.9,
        scrollTo: {
          y: target,
          offsetY: headerHeight
        },
        ease: 'power2.out'
      });
    });
  });

  updateCurrentNav();
  window.addEventListener('scroll', updateCurrentNav, { passive: true });
  window.addEventListener('resize', updateCurrentNav);
});

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  const extraOffset = 100;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});


/***********************************************************************
　SERVICE スライダー
***********************************************************************/

const initServiceSwiper = () => {
  const serviceSlider = document.querySelector('.service_swiper');
  if (!serviceSlider) return;


  // サイドのオフセット計算（1024px以上なら画面幅の7%を余白に）
  const serviceSideOffset = window.innerWidth > 1024 ? window.innerWidth * 0.07 : 0;

  // 2. Swiperの初期化
  const serviceSwiper = new window.Swiper(serviceSlider, {
    slidesOffsetBefore: serviceSideOffset,
    slidesOffsetAfter: serviceSideOffset,
    loop: false,
    speed: 700,
    spaceBetween: 30,
    slidesPerView: 3,
    navigation: {
      nextEl: '.service_nav_next',
      prevEl: '.service_nav_prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 22,
      },
      1025: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
    },
  });
};



/***********************************************************************
　humberger menu
***********************************************************************/
window.addEventListener('load', () => {
  const navEle = document.querySelector('.hd_menu-toggle');
  const navWrap = document.querySelector('.hd_nav');

  // メニューを閉じる関数
  const closeMenu = () => {

    // パネル自体も同時に左へスライド
    navWrap.classList.add('hide-panel');
    setTimeout(() => {
      navWrap.classList.remove('is_open', 'hide-panel');
    }, 500); // CSSトランジション時間に合わせる

    navEle.classList.remove('is_open');
  };

  // ハンバーガーメニュークリック
  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    if (!isOpen) {
      // 開くとき
      navWrap.classList.add('is_open');


      navEle.classList.add('is_open');
    } else {
      // 閉じるとき
      closeMenu();
    }
  });

  // グローバルナビ内のリンクとボタンをクリックした時にメニューを閉じる（768px以下の時のみ）
  const navLinks = navWrap.querySelectorAll('a, button');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      // 画面幅768px以下の場合のみメニューを閉じる
      if (window.innerWidth <= 768 && navWrap.classList.contains('is_open')) {
        closeMenu();
      }
    });
  });
});





/***********************************************************************
　header表示・非表示
***********************************************************************/

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const mainImg = document.querySelector('.mainimg');
  const desktopMq = window.matchMedia('(min-width: 769px)');
  const isAlwaysVisiblePage = document.body.classList.contains('error404') || document.body.classList.contains('complete');

  if (!header || !mainImg) return;

  if (isAlwaysVisiblePage) {
    header.classList.add('is-active');
    return;
  }

  const updateHeader = () => {
    // スマホサイズ（768px以下）の場合は、常にクラスを外してリセット
    if (!desktopMq.matches) {
      header.classList.remove('is-active');
      return;
    }

    // メイン画像の下端が画面の最上部(0)より上にあるか判定
    const mainImgBottom = mainImg.getBoundingClientRect().bottom;
    const isPastMainImg = mainImgBottom <= 0;

    // toggleの第2引数に条件式を入れることで、真なら付与、偽なら削除
    header.classList.toggle('is-active', isPastMainImg);
  };

  updateHeader();

  window.addEventListener('scroll', updateHeader, { passive: true });
  
  // 画面サイズ変更時
  window.addEventListener('resize', updateHeader);
  
  // PC/スマホの境界線を跨いだ時
  desktopMq.addEventListener('change', updateHeader);
});







/***********************************************************************
　RECRUIT タブ切り替え
***********************************************************************/

document.addEventListener('DOMContentLoaded', () => {
  const tabBtns = document.querySelectorAll('.recruit_tab_btn');
  const panels = document.querySelectorAll('.recruit_job_panel');
  const tabsWrap = document.querySelector('.recruit_tabs');
  const panelsWrap = document.querySelector('.recruit_panels');
  const mobileMq = window.matchMedia('(max-width: 768px)');
  const panelFadeClass = 'is-switching';
  let panelFadeTimer = null;

  if (!tabBtns.length || !panels.length || !tabsWrap || !panelsWrap) return;

  const panelMap = new Map();
  panels.forEach(panel => {
    if (panel.id) panelMap.set(panel.id, panel);
  });

  const orderedPanelIds = Array.from(tabBtns)
    .map(btn => btn.getAttribute('data-target'))
    .filter(Boolean);

  const clearActiveState = () => {
    tabBtns.forEach(btn => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('aria-expanded', 'false');
    });

    panels.forEach(panel => {
      panel.classList.remove('is-active');
    });
  };

  const triggerPanelsFade = () => {
    if (mobileMq.matches) return;

    panelsWrap.classList.remove(panelFadeClass);
    if (panelFadeTimer !== null) {
      window.clearTimeout(panelFadeTimer);
      panelFadeTimer = null;
    }

    void panelsWrap.offsetWidth;
    panelsWrap.classList.add(panelFadeClass);

    panelFadeTimer = window.setTimeout(() => {
      panelsWrap.classList.remove(panelFadeClass);
      panelFadeTimer = null;
    }, 360);
  };

  const openTab = (selectedBtn, { withAnimation = true } = {}) => {
    clearActiveState();
    selectedBtn.classList.add('is-active');
    selectedBtn.setAttribute('aria-selected', 'true');
    selectedBtn.setAttribute('aria-expanded', 'true');

    const target = selectedBtn.getAttribute('data-target');
    const targetPanel = target ? document.getElementById(target) : null;
    if (targetPanel) {
      targetPanel.classList.add('is-active');
    }

    if (withAnimation) {
      triggerPanelsFade();
    }
  };

  const movePanelsToAccordion = () => {
    tabsWrap.classList.add('is-accordion');
    panelsWrap.classList.add('is-hidden-mobile');

    tabBtns.forEach(btn => {
      const target = btn.getAttribute('data-target');
      const panel = target ? panelMap.get(target) : null;
      if (panel && btn.nextElementSibling !== panel) {
        btn.insertAdjacentElement('afterend', panel);
      }
    });
  };

  const restorePanelsToTabs = () => {
    tabsWrap.classList.remove('is-accordion');
    panelsWrap.classList.remove('is-hidden-mobile');

    orderedPanelIds.forEach(id => {
      const panel = panelMap.get(id);
      if (panel) {
        panelsWrap.appendChild(panel);
      }
    });
  };

  const applyMode = () => {
    if (mobileMq.matches) {
      movePanelsToAccordion();
      clearActiveState();
      return;
    }

    restorePanelsToTabs();
    const currentActive = document.querySelector('.recruit_tab_btn.is-active');
    const fallbackBtn = currentActive || tabBtns[0];
    if (fallbackBtn) {
      openTab(fallbackBtn, { withAnimation: false });
    }
  };

  applyMode();

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (mobileMq.matches) {
        const isActive = btn.classList.contains('is-active');
        if (isActive) {
          clearActiveState();
          return;
        }
      }

      openTab(btn, { withAnimation: true });
    });
  });

  mobileMq.addEventListener('change', applyMode);
});




/***********************************************************************
  　慣性スクロール
***********************************************************************/
const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);





/***********************************************************************
  　フェードアップ
***********************************************************************/
const initFadeUp = () => {
  const targets = document.querySelectorAll('.fade_up');
  

  const options = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is_show');
        observer.unobserve(entry.target);
      }
    });
  }, options);

  targets.forEach(target => {
    observer.observe(target);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initServiceSwiper();
  initFadeUp();
});

